module.exports = __webpack_public_path__ + "/images/testimonial-marta.b26ea80.jpg";